import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

export enum formatting {
  datetime = 'Y-MM-DD h:mm:ss A', //2018-01-25 11:54:39 AM
  date = 'Y-MM-DD', //2018-01-25
  month = 'MMMM Y', //January 2018
  utc = 'YYYY-MM-DD[T00:00:00Z]', //2018-01-25T00:00:00Z
  longDate = 'dddd MMMM Do, YYYY', //Thursday January 25th, 2018
  shortSpoken = 'MMM D, Y', //Jan 25, 2018
  longSpoken = 'MMMM D, Y', //January 25, 2018
}

export function formatDate(
  date: Date | string,
  format: formatting,
  translateEmpty?: string,
  useLocalTime?: boolean,
): string {
  translateEmpty = translateEmpty ? translateEmpty : '';
  if (!date) {
    return translateEmpty;
  }

  if (typeof date === 'string') {
    date = new Date(date);
    if (date.toString() === 'Invalid Date') {
      return date.toString();
    }
  }

  let m = moment(date.toISOString());
  if (format === formatting.utc || !useLocalTime) {
    m = moment.utc(date.toISOString());
  }

  return m.format(format);
}

@Pipe({ standalone: true, name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
  transform(date: Date | string, format: formatting, translateEmpty?: string, useLocalTime?: boolean): string {
    return formatDate(date, format, translateEmpty, useLocalTime);
  }
}
